import Marquee from "react-fast-marquee";

export function EditorialMarquee({ text = "BUILDING KINGDOM LEADERS FOR GLOBAL IMPACT", className = "" }) {
  const items = Array(6).fill(text);
  return (
    <div className={`relative border-y border-gold-500/20 py-8 md:py-10 bg-ink-royal/20 ${className}`} data-testid="editorial-marquee">
      <Marquee speed={35} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-accent italic text-4xl md:text-6xl lg:text-7xl text-white/90 px-8 whitespace-nowrap">
              {t}
            </span>
            <span className="text-gold-500 text-3xl md:text-5xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
